import { ProfileService } from './../../services/profile.services';

import { AppConfiguration } from '../conf/app.configuration';
import { AuthService } from '../auth.service';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '../../../node_modules/@angular/router';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppState } from '../store/AppState';
import { UserService } from '../user.service';

import { flatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthGuard } from './auth-guard.service';
import { ServiceLocator } from '../ServiceLocator';
import { Injectable } from '@angular/core';

@Injectable()
export class FENewGuard extends AuthGuard {
  enabled = true;
  profileService: ProfileService;
  constructor(
    userService: UserService,
    appConfig: AppConfiguration,
    auth: AuthService,
    router: Router,
    store: Store<AppState>
  ) {
    super(appConfig, auth, router, store);
    this.profileService = ServiceLocator.injector.get(ProfileService);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log('canActivate ProfileGuard');

    return super.canActivate(route, state).pipe(
      flatMap(
        (canActivate: boolean) => {
          if (canActivate) {
            if (this.profileService.newDossierEnabled) {
              return of(true);
            } else {
              console.error('No dispone de perfil para acceder a la ruta', route);
              this.router.navigate(['accesoDenegado']);
            }
          }
        })
    )

  }





}
